import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { PlayerFilterPipe } from '../app/pipes/player-filter.pipe';
import { StandingsFilterPipe } from '../app/pipes/standings-filter.pipe';

import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireModule } from '@angular/fire';
import { environment } from '../environments/environment';

import { AngularDraggableModule } from 'angular2-draggable';
import { MatchReportPipe } from '../app/pipes/match-report.pipe';

import { LinkyModule } from 'ngx-linky';
import { ChatFormatPipe } from './pipes/chat-format.pipe';

@NgModule({
  declarations: [
    AppComponent,
    PlayerFilterPipe,
    StandingsFilterPipe,
    MatchReportPipe,
    ChatFormatPipe
  ],
  imports: [
    AngularDraggableModule,
    BrowserModule,
    HttpClientModule,
    FormsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    LinkyModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
